import classnames from 'classnames'
import React from 'react'

/**
 * The backdrop of the dialog, closes the dialog on click
 */
export function DialogOverlay(props: React.HTMLProps<HTMLDivElement>) {
  return (
    <div
      {...props}
      aria-hidden
      data-testid="dialog-overlay"
      className={classnames(props.className, 'js-dialog-overlay absolute bottom-0 left-0 right-0 top-0')}
    />
  )
}
